import {useState} from 'react';
import { useHistory } from 'react-router-dom';
import {IClass} from '../../../pages/RandomSampler/Config/RandomSampler.types';
import utilService from '../../../services/utilService';

const useCreateAutoProjectButtons = (autoProjectState, editDraftAutoProject, initialNewAutoProject, setState, navigateToDataProjects, runAutoClassifier, navigateToAutoStatusPage, chosenTags) => {
    const [isDisabled, setIsDisabled] = useState(false);
    const history = useHistory();

    /**
     * setClassesForRandomPage - when page is init it set the classes as the object need to be like IClass
     */
    const setClassesForRandomPage = () => {
        const copyClasses = JSON.parse(JSON.stringify(autoProjectState.classes));
        const randomClasses:IClass[] = [];

        copyClasses.forEach((cl) => {
            const image_obj = cl.imageList.length > 0 ? cl.imageList[0] : {url: 'error'};

            randomClasses.push({
                isChosen: false,
                isShowAddToClassSuccess: false,
                isShowAddToClassError: false,
                tagId: cl.tag_id,
                name: cl.tag_name,
                img: {
                    fileServerId: image_obj.serverId,
                    url: image_obj.url,
                    title: image_obj.name
                }
            });
        });

        return randomClasses;
    };

    /**
     * when user wants to go back to auto random sampler
     */
    const goBackToRandomSampler = () => {
        const newPath = utilService.replaceLastRoute('auto_classification_random_sampler', 2);

        history.replace({
            pathname: newPath,
            state: {projectIdInit: autoProjectState.projectId, classes: setClassesForRandomPage()}
        });
    };

    /**
     * handleOpenConfirmBtnClick - when start auto btn is clicked,
     */
    const handleOpenConfirmBtnClick = () => {
        setState({openCreateProjectModal: true});
    };

    /**
     * handleDraftBtnClick - when draft btn is clicked,
     * if the project is already initialed - calls edit draft
     * else - call initialNewAutoProject and edit draft
     */
    const handleDraftBtnClick = async () => {
        try {
            if (autoProjectState.isProjectInitialized && autoProjectState.projectName) {
                await editDraftAutoProject();
                navigateToDataProjects();
            } else if (autoProjectState.projectName) {
                const project_id = await initialNewAutoProject(autoProjectState.projectName);

                await editDraftAutoProject(project_id);
                navigateToDataProjects();
            } else {
                setState({showProjectNameError: true});
                scrollToTopPage();
            }
        } catch (e) {
            console.log(e);
        }
    };

    /**
     * handleSaveBtnClick - check if there is a name for the project,
     * save the project and go to all projects page
     */
    const handleSaveBtnClick = async () => {
        setIsDisabled(true);
        if (autoProjectState.projectName) {
            let project_id = -1;

            try {
                project_id = await initialNewAutoProject(autoProjectState.projectName, {}, chosenTags);
            } catch (e) {
                return;
            }
            if (project_id > -1) {
                await runAutoClassifier(project_id, chosenTags);
                navigateToAutoStatusPage(project_id);

            }
        } else {
            setState({showProjectNameError: true});
        }
        setIsDisabled(false);

    };

    const scrollToTopPage = () => {
        const element = document.getElementById('create-auto-project-title-box');

        element && element!.scrollIntoView({behavior: 'smooth', block: 'center'});
    };

    return {
        handleDraftBtnClick,
        handleSaveBtnClick,
        handleOpenConfirmBtnClick,
        isDisabled,
        goBackToRandomSampler
    };
};

export default useCreateAutoProjectButtons;
